import Icon from "./IconBase.js";

const CopyIcon = (props) => (
  <Icon width="24" height="24" {...props}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.75 9H11.75C10.6454 9 9.75 9.89543 9.75 11V20C9.75 21.1046 10.6454 22 11.75 22H20.75C21.8546 22 22.75 21.1046 22.75 20V11C22.75 9.89543 21.8546 9 20.75 9Z"
        stroke="#6f6f6f"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.75 15H4.75C4.21957 15 3.71086 14.7893 3.33579 14.4142C2.96071 14.0391 2.75 13.5304 2.75 13V4C2.75 3.46957 2.96071 2.96086 3.33579 2.58579C3.71086 2.21071 4.21957 2 4.75 2H13.75C14.2804 2 14.7891 2.21071 15.1642 2.58579C15.5393 2.96086 15.75 3.46957 15.75 4V5"
        stroke="#6f6f6f"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Icon>
);

export default CopyIcon;
